<audit-notice-display [audit]="audit!"></audit-notice-display>

<div *ngIf="audit?.IsMemoAudit()">Scan a Memo item to audit its Collated Set</div>
<table class="kit-list">
    <tr *ngFor="let kit of audit?.kits">
        <td style="min-width:32px;">
            <mat-icon *ngIf="kit.PartiallyChecked()">checkmark</mat-icon>
            <mat-icon *ngIf="kit.AllChecked()">done_all</mat-icon>
        </td>
        <td style="width:100%;">
            <button mat-raised-button color="primary"
                [disabled]="kit.items.length == 0"
                (click)="gotoKitAudit(kit)">{{kit.Description}}</button>
        </td>
        <td class="audit-progress">{{kitAuditProgress(kit)}}</td>
    </tr>

    <tr>
        <td colspan="3"><mat-divider></mat-divider></td>
    </tr>    
    <tr>
        <td></td>
        <td style="width:100%;">
            <div *ngIf="this.audit?.IsBinderAudit()" style="padding-bottom:0.5em;">
                <mat-checkbox [(ngModel)]="anyBinderShellsPlaced">Any empty binder shells being placed?</mat-checkbox>
            </div>

            <button mat-raised-button color="accent" *ngIf="anyItemsToOrder() || !anyBindersAudited()" [disabled]="!anyItemsToOrder()"
                (click)="createMissingItemOrder()">Order Missing Items</button>
                <button mat-raised-button color="accent" *ngIf="!anyItemsToOrder() && anyBindersAudited()"
                (click)="updateCustomerSampleBooks()">Update Audited Sample Books</button>
        </td>
        <td></td>
    </tr>
</table>

<ng-template #emptyBinderShellSelectionTemplate>
    <h4>Which binder shells are you placing?</h4>
    <mat-dialog-content>
        <div *ngFor="let binder of BinderShells" class="empty-binder-shell-prompt">
            <mat-checkbox [(ngModel)]="audit.placedEmptyShells[binder.EmptyShellItem.InventoryID]">{{binder.EmptyShellItem.Description}}</mat-checkbox>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="accent" [mat-dialog-close]="false" style="margin-right:1em;">Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="true">OK</button>
    </mat-dialog-actions>
</ng-template>